import PreLoader from "components/PreLoader/PreLoader";
import { Content } from "containers/RightPanel/RightPanel.styles";
import { fadeIn } from "react-animations";
import styled, { css, keyframes } from "styled-components";

export const SpinnerSection = styled.section`
  width: 100%;
  margin-bottom: 15px;
  min-height: 390px;
  display: flex;
  align-items: center;
`;

export const Spinner = styled(PreLoader)``;

const fadeInAnimation = css`
  animation: 0.5s ${keyframes`${fadeIn}`} !important;
`;

export const ContentContainer = styled(Content)`
  ${fadeInAnimation}
`;

export const Container = styled.div`
  width: 100%;
  margin-bottom: 10px;
`;

export const Title = styled.div`
  width: 100%;
`;

export const ImageSection = styled.section`
  width: 100%;
  margin-bottom: 15px;
  min-height: 390px;

  & > div {
    margin-bottom: 0 !important;
    ${fadeInAnimation}

    & > label {
      ${({ theme }) =>
        theme.range(
          "margin-left",
          "0px",
          "10px",
          `${theme.breakpoints.md}px`,
          `${theme.breakpoints.lg}px`,
        )};
    }
  }
`;

export const ParcelInfoContainer = styled.div`
  display: flex;
  height: 39px;
  line-height: 39px;
  flex-direction: row;
  justify-content: space-between;
`;

export const ParcelInfoKey = styled.span`
  color: ${({ theme }) => theme.darkGrey};
`;

export const ParcelInfoValue = styled.span`
  color: ${({ theme }) => theme.black};
  font-weight: bold;
`;
